import React from "react";
import LockIcon from "assets/img/lock.svg";

const LockInfo = () => (
  <div className="lender-lock-info">
    <img src={LockIcon} alt="" className="lender-lock-info__icon" />
    <span className="lender-lock-info__text">
      Your terms and payment amount are recalculated once your cart fits your
      pre-approval and you submit the changes.
    </span>
  </div>
);

export default LockInfo;
